import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const ExpandContainer = styled(Box)`
    align-items: center;
    line-height: 24px;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
`;

export const CellText = styled(Box)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
`;

export const ExpandText = styled(Typography)`
    padding: 8px;
`;